import Accessibility from "./Accessibility";
import { ArchiveBoard } from "./ArchiveBoard";
import BoardOwner from "./BoardOwner";
import Delete from "./Delete";
import KeyName from "./KeyName";
import Workflow from "./Workflow";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { ViewWeekOutlinedIcon } from "../../../../../utils/constants/icons.js";
// Define columns as a custom hook
export const columns = (isMobile) => {
  return [
    {
      field: "is_archive",
      headerName: "Status",
      minWidth: 85,
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center board-table-archive-column">
          {/* <img src={ActiveIcon} alt="Active Icon" /> */}
          <ViewWeekOutlinedIcon />
        </div>
      ),
      renderCell: (params) => {
        return (
          <ArchiveBoard isArchive={!params.value} id={params.row.board_id} />
        );
      },
      flex: 0.6,
      sortable: false,
      headerClassName: "center-header",
    },
    {
      field: "board_name",
      headerName: "Board Name",
      minWidth: isMobile ? 250 : 300,
      flex: 1.5,
    },
    {
      field: "key",
      headerName: "Key",
      minWidth: 100,
      renderCell: (params) => {
        return <KeyName params={params} />;
      },
      flex: 0.5,
      sortable: false,
    },
    {
      field: "board_owner_name",
      headerName: "Board Owner",
      minWidth: 200,
      renderCell: (params) => {
        return <BoardOwner params={params} />;
      },
      flex: 1.2,
      sortable: false,
    },
    {
      field: "workflow_name",
      headerName: "Workflow",
      minWidth: isMobile ? 110 : 150,
      renderCell: (params) => {
        return <Workflow params={params} />;
      },
      flex: 0.8,
      sortable: false,
    },
    {
      field: "is_private",
      headerName: "Is Private",
      minWidth: 150,
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p className="size-14 text-color weight-500">Is Private</p>
        </div>
      ),
      renderCell: (params) => {
        return <Accessibility isPrivate={params.value} params={params} />;
      },
      flex: 1,
      sortable: false,
      headerClassName: "center-header",
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => {
        return <Delete id={params.row.board_id} />;
      },
      sortable: false,
    },
  ];
};
